function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
import { cloneDeepWith as i, copyProperties as n } from "../../object/cloneDeepWith.js";
import { argumentsTag as s, booleanTag as p, stringTag as f, numberTag as g } from "../_internal/tags.js";
function h(e, o) {
  return i(e, function (c, l, u, a) {
    var r = o === null || o === void 0 ? void 0 : o(c, l, u, a);
    if (r != null) return r;
    if (_typeof(e) == "object") switch (Object.prototype.toString.call(e)) {
      case g:
      case f:
      case p:
        {
          var t = new e.constructor(e === null || e === void 0 ? void 0 : e.valueOf());
          return n(t, e), t;
        }
      case s:
        {
          var _t = {};
          return n(_t, e), _t.length = e.length, _t[Symbol.iterator] = e[Symbol.iterator], _t;
        }
      default:
        return;
    }
  });
}
export { h as cloneDeepWith };